import { render, staticRenderFns } from "./Product-Management.vue?vue&type=template&id=a5ae6d42&scoped=true"
import script from "./Product-Management.vue?vue&type=script&lang=js"
export * from "./Product-Management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ae6d42",
  null
  
)

export default component.exports